import React from "react";
import classNames from "classnames";

import { Identifiable, Folder as F } from "@planzone/dto";
import { useRetrieveDocuments } from "@planzone/view-models";
import { SelectList } from "@common/selectList";
import { ToggleArrowIcon } from "@common/assets/toggleArrowIcon";
import { Folder } from "./folder";
import { Props } from "./types";
import styles from "./styles.scss";

function filterFolderTree(
  folder: Identifiable<F>,
  sourceFolderUuid: string | undefined,
): Identifiable<F> {
  return {
    ...folder,
    children: folder.children
      .filter(
        (child) => child.type !== "folder" || child.uuid !== sourceFolderUuid,
      )
      .map((child) =>
        child.type === "folder"
          ? filterFolderTree(child as Identifiable<F>, sourceFolderUuid)
          : child,
      ),
  };
}

function FolderSelection({
  namespace,
  type,
  placeholder,
  selectedFolder,
  projectName,
  sourceFolder,
  select,
}: Props) {
  const {
    isRequestPending,
    isRequestSuccess,
    isRequestFailure,
    folder,
    retrieveDocuments,
  } = useRetrieveDocuments(namespace, type);
  const filteredFolder = sourceFolder
    ? filterFolderTree(folder, sourceFolder.uuid)
    : folder;

  React.useEffect(() => {
    !isRequestPending &&
      !isRequestSuccess &&
      !isRequestFailure &&
      retrieveDocuments({ namespace, type });
  }, [namespace]);

  return (
    <SelectList
      rootClassName={styles.folderSelection}
      listClassName={styles.listRoot}
    >
      {({ isOpen, select: s }) => ({
        input: (
          <div
            className={classNames(styles.input, { [styles.opened]: isOpen })}
          >
            {selectedFolder ? (
              <p>{selectedFolder.name}</p>
            ) : (
              <p className={styles.placeholder}>{placeholder}</p>
            )}
            <ToggleArrowIcon className={styles.icon} />
          </div>
        ),
        list: (
          <div className={styles.list}>
            <Folder
              folder={filteredFolder}
              selectedFolder={selectedFolder}
              projectName={projectName}
              type={type}
              select={(folder) => s(select(folder))}
            />
          </div>
        ),
      })}
    </SelectList>
  );
}

export { FolderSelection };
